import {useEffect} from 'react'

export default function Slider (props) {
  useEffect(() => {
    (
      document.querySelector('#wp-block-gds-lead-form__steps') ||
      document.querySelector('#wp-block-gds-lead-form__pages')
    )?.scrollIntoView({
      behavior: 'smooth',
    })
  }, [props.page])
  return (
    <div
      id="wp-block-gds-lead-form__pages"
      className="wp-block-gds-lead-form__pages"
      style={{
        transform: `translateX(-${(props.page || 0) * 100}vw)`,
        opacity: props.leaving ? 0.0 : 1.0
      }}
    >
      {props.children}
    </div>
  )
}
